module.exports = __webpack_public_path__ + "img/f03.9b6efe35.webp";